<template>
  <div>
    <div class="around-fade"></div>
    <div class="zone-modal">
      <b-overlay
        class="declaration-overlay"
        rounded="lg"
        :show="!dataLoaded && !!movedDeclarationId"
        v-if="!dataLoaded && !!movedDeclarationId"
      />

      <CloseModalButton :on-click="closeMoveDeclarationModal"></CloseModalButton>

      <div class="header">
        <h1>Przenieś deklarację do nowego budynku</h1>
      </div>

      <div v-if="declaration != null">
        <div style="height: 10em; overflow-y: auto">
          <div>Deklaracja {{ declaration.type }} dla budynku {{ declaration.address }}.</div>
        </div>

        <div class="mt-2">
          <div><b>Wskaż docelowy budynek:</b></div>

          <b-form-select
            v-if="buildings != null"
            v-model="buildingData"
            :options="buildingsFormatted"
            :select-size="4"
          />

          <b-form-select
            v-if="buildings == null"
            disabled="disabled"
            :options="[{value: -1, text: 'Wczytuję budynki...' }]"
            :select-size="4"
          />

          <b-form-input v-model="search" placeholder="Wyszukaj budynek" class="mt-1"></b-form-input>
        </div>
      </div>

      <div class="buttons-row">
        <button type="button" class="btn btn-outline-primary" @click="openBuildingsModal" style="float: left">
          Dodaj budynek
        </button>
        <button type="button" class="btn btn-outline-primary" @click="closeMoveDeclarationModal()">
          Zamknij
        </button>
        <button type="button" class="btn btn-primary" @click="moveFinal()" :disabled="(buildingData == '') || (declaration == null)">
          Przenieś
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import DeclarationsModel from "@/models/declarations";
import LocationsModel from "@/models/locations";
import DeclarationsMixin from "@/mixins/DeclarationsMixin";
import CloseModalButton from "@/components/common/CloseModalButton";
import _ from "lodash";
import axios from "axios";

export default {
  name: "MoveDeclarationModal",
  components: { CloseModalButton },
  mixins: [DeclarationsMixin],
  data() {
    return {
      dataLoaded: false,
      declaration: null,
      buildings: null,
      buildingData: "",
      search: ""
    }
  },
  methods: {
    closeMoveDeclarationModal() {
      this.$store.commit("closeMoveDeclarationModal");
    },
    moveFinal() {
      DeclarationsModel.moveDeclaration(this.$store.state.movedDeclarationId, this.buildingData.id)
        .then((res) => {
          this.$store.commit("closeMoveDeclarationModal");
          this.$store.commit('updateDeclarationsList');
          this.$notify({
            group: 'zone',
            type: 'success',
            title: 'Sukces',
            text: 'Przepisano deklarację do wybranego budynku'
          });
        });
    },
    openBuildingsModal() {
      this.$store.commit("openBuildingsModal");
    },
    loadBuildings() {
      this.buildings = null;
      return axios.get('/api/locations/buildings').then((rres) => {
        this.buildings = rres.data;
      });
    },
    performAddressSearch: _.debounce(function() {
      var srch = this.search.trim();
      this.buildings = null;
      if (srch.length) {
        LocationsModel.getUserBuildings(0, -1, -1, false, srch)
          .then((res) => this.buildings = res.data);
      } else {
        return axios.get('/api/locations/buildings').then((rres) => {
          this.buildings = rres.data;
        });
      }
    }, 500)
  },
  computed: {
    movedDeclarationId() {
      return this.$store.state.movedDeclarationId;
    },
    buildingsFormatted() {
      let result = [];
      if (this.buildings !== null) {
        this.buildings.forEach((building) => {
          result.push({
            value: building,
            text: building.formatted_address
          });
        })
      }
      return result;
    }
  },
  mounted() {
    if (this.movedDeclarationId) {
      DeclarationsModel.getDeclarationSummaryById(this.movedDeclarationId)
        .then((res) => {
          this.declaration = res.data;
          this.dataLoaded = true;
          return this.loadBuildings();
        });
    }

    var obj = this;
    this.$root.$on('reloadBuildingsIfNeeded', () => {
      obj.loadBuildings();
    });
  },
  watch: {
    "search": function () {
      this.performAddressSearch();
    }
  }
}
</script>

<style scoped>
h1, h2, h3, h4, label, p {
  color: #707070;
}


.zone-modal {
  width: 44rem;
  height: 30rem;
  padding: 1.5rem;
  z-index: 10000;
}

.header {
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 1;
}

h1 {
  font-size: 1.3rem;
}

h2 {
  font-size: 1.2rem;
  font-family: "Volte Semibold", serif;
}

.zone-modal .buttons-row {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  display: block;
  width: 96%;
  text-align: right;
  white-space: nowrap;
}

.buttons-row .btn-primary, .buttons-row .btn-outline-primary {
  min-width: 8rem;
  margin-left: 1rem;
  height: 2rem;
}

.declaration-overlay {
  position: absolute !important;
  top: 4rem;
  left: 0;
  right: 0;
  bottom: 0;
}

@media (max-height: 770px) {
  .zone-modal {
    height: 30rem;
  }
}

.table {
  width: 100%;
}
</style>
